import React from 'react';

/** components */
import LabelWithTooltip from './LabelWithTooltip';

import { MONTH_NAMES } from '../../constants';

/** helpers */
import { validateInputField } from '../../helpers/validation';

const ShortDatePicker = ({
  data,
  setData,
  field,
  dataError,
  setDataError,
  fieldClassName,
  toggleFieldModal,
  isModalOpen,
  initializeSectionError,
}) => {
  const dateValues = data[field.name] ? data[field.name].split('-') : ['', ''];

  const handleChangeYear = (event) => {
    initializeSectionError();
    const value = event.target.value;
    const length = value.length;

    if (length <= 4) {
      setData({
        ...data,
        [field.name]: value + '-' + dateValues[1],
        [field.name + 'year']: value,
      });
    }
  };

  return (
    <>
      <div key={field.name} className={fieldClassName}>
        <div className="form-field">
          <LabelWithTooltip
            field={field}
            toggleFieldModal={toggleFieldModal}
            isModalOpen={isModalOpen}
          />
          <div className="datePicker">
            <div className="shortDate-m">
              <select
                onChange={(e) =>
                  setData({
                    ...data,
                    [field.name]: dateValues[0] + '-' + ('0' + e.target.value).slice(-2),
                    [field.name + 'month']: e.target.value,
                  })
                }
                value={Number(dateValues[1])}
                name={field.name + 'month'}
                placeholder="Month"
              >
                <option value="0">Month</option>
                {MONTH_NAMES.map((option, index) => (
                  <option value={index + 1} key={'option' + option + index}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="shortDate-y">
              <input
                type="number"
                placeholder="Year"
                min="1900"
                name={field.name + 'year'}
                value={dateValues[0] || ''}
                onBlur={() =>
                  validateInputField(dateValues[0], field.name + 'year', field, setDataError)
                }
                onChange={(e) => handleChangeYear(e)}
                spellCheck={false}
              />
            </div>
          </div>
        </div>
        {dataError[field.name] && <p className="error-text">{dataError[field.name]}</p>}
      </div>
    </>
  );
};

export default ShortDatePicker;
